import { Component } from "react"
import PropTypes from "prop-types"
import find from "lodash/find"
import isEmpty from "lodash/isEmpty"
import _map from "lodash/map"
import groupBy from "lodash/groupBy"

import { put, post, del } from "shared/lib/api"
import sluggify from "shared/lib/sluggify"
import stepFieldsValidator from "../shared/step_fields_validator"
import fieldTypes from "partners/components/shared/action_field_types"
import displayFlash from "partners/scripts/display_flash"
import { rejectedXHRPromiseLogger } from "shared/lib/xhr_promise"

export default class ActionFieldsForm extends Component {
  static propTypes = {
    service_slug: PropTypes.string.isRequired,
    authenticity_token: PropTypes.string.isRequired,
    action_id: PropTypes.number.isRequired,
    id: PropTypes.number,
    slug: PropTypes.string,
    name: PropTypes.string,
    shareable: PropTypes.bool,
    required: PropTypes.bool,
    helper_text: PropTypes.string,
    populator_values: PropTypes.array,
    action_field_type: PropTypes.number,
    field_type: PropTypes.string,
    content_type: PropTypes.string,
    destructive: PropTypes.bool,
    platformUnpublished: PropTypes.bool,
    populatorTemplate: PropTypes.string.isRequired,
  }

  static defaultProps = {
    action_field_type: 1,
    content_type: "folder",
    required: true,
    shareable: true,
    populator_values: [],
    field_type: "TEXT_FIELD",
    destructive: false,
  }

  state = {
    populatedStaticValues: this.props.populator_values,
    actionFieldType: this.props.action_field_type,
    helperText: this.props.helper_text,
    slug: this.props.slug,
    name: this.props.name,
    id: this.props.id,
    required: this.props.required ? "true" : "false",
    shareable: this.props.shareable ? "true" : "false",
    fieldType: this.props.field_type,
    contentType: this.props.content_type,
    populatorType: "dropdown_static",
    destructive: this.props.destructive,
    errors: {},
  }

  UNSAFE_componentWillMount() {
    if (this.state.actionFieldType !== undefined) {
      if (
        ["COLLECTION_SELECT", "CHECKBOX_MULTI"].includes(this.state.fieldType)
      ) {
        this.setState({
          populatorType: this.findItemIdById(this.state.actionFieldType).value,
        })
      } else {
        this.setState({
          contentType: this.findItemIdById(this.state.actionFieldType).value,
        })
      }
    }
  }

  handleNameBlur = () => {
    if (this.state.slug === undefined && this.state.name) {
      this.setState({ slug: sluggify(this.state.name) })
    }
  }

  handleHelperTextChange = event => {
    this.setState({ helperText: event.target.value })
  }

  handleSlugChange = event => {
    this.setState({ slug: event.target.value })
  }

  handleNameChange = event => {
    this.setState({ name: event.target.value })
  }

  handleRequiredChange = event => {
    this.setState({ required: event.target.value })
  }

  handleShareableChange = event => {
    this.setState({ shareable: event.target.checked ? "false" : "true" })
  }

  handleFieldTypeChange = event => {
    this.setState({ fieldType: event.target.value })
  }

  handleContentTypeChange = event => {
    this.setState({ contentType: event.target.value })
  }

  handlePopulatorTypeChange = event => {
    this.setState({ populatorType: event.target.value })
  }

  handleClickAddStaticField = event => {
    event.preventDefault()
    let { populatedStaticValues } = this.state
    populatedStaticValues.push({ name: "", value: "" })

    this.setState({
      populatedStaticValues,
    })
  }

  handleClickRemoveStaticField = index => {
    let { populatedStaticValues } = this.state

    if (populatedStaticValues.length >= 2) {
      populatedStaticValues.splice(index, 1)
      this.setState({
        populatedStaticValues,
      })
    }
  }

  populateStaticValues = (index, type, value) => {
    let rows = this.state.populatedStaticValues
    rows[index][type] = value

    this.setState({ populatedStaticValues: rows })
  }

  payLoad() {
    return {
      authenticity_token: this.props.authenticity_token,
      partners_action_field: {
        action_field_type: this.selectedActionFieldValue(),
        populator_values: this.state.populatedStaticValues,
        helper_text: this.state.helperText,
        required: this.state.required,
        shareable: this.state.shareable,
        slug: this.state.slug,
        name: this.state.name,
        module_name: this.props.service_slug,
        action_id: this.props.action_id,
      },
    }
  }

  selectedActionFieldValue() {
    if (
      ["COLLECTION_SELECT", "CHECKBOX_MULTI"].includes(this.state.fieldType)
    ) {
      return this.findItemIdByValue(this.state.populatorType).id
    } else if (this.state.fieldType === "DOUBLE_COLLECTION_SELECT") {
      return this.findItemIdBySlugAndValue(
        "double_dropdown_field_type",
        "dropdown_dynamic"
      ).id
    } else if (this.state.contentType) {
      return this.findItemIdByValue(this.state.contentType).id
    } else {
      return undefined
    }
  }

  handleClickSave = event => {
    event.preventDefault()

    let confirm = true
    let _errors = stepFieldsValidator(this.payLoad().partners_action_field)

    this.setState({ errors: _errors })

    if (this.fieldTypeWillChange() && this.state.destructive) {
      confirm = window.confirm(
        "Are you sure you want to change the action field type? All Applets using the parent action will be deleted."
      )
    }

    if (!isEmpty(_errors)) {
      displayFlash(
        "Could not save this action field. Please check your data!",
        "error"
      )
    } else if (confirm) {
      let url = `/services/${this.props.service_slug}/actions/${this.props.action_id}/action_fields`
      let method = post
      let verb = "created"

      if (this.props.id !== undefined) {
        url = `/services/${this.props.service_slug}/actions/${this.props.action_id}/action_fields/${this.props.slug}`
        method = put
        verb = "updated"
      }

      method(url, this.payLoad())
        .then(() => {
          displayFlash(`Action field ${verb}`)
        })
        .catch(
          rejectedXHRPromiseLogger(({ response }) => {
            displayFlash(
              "There has been an error updating this action field.",
              "error"
            )
            this.parseErrors(response.errors || {})
          })
        )
    }
  }

  handleClickDeleteActionField = event => {
    event.preventDefault()
    const confirm = window.confirm(
      "Are you sure you want to PERMANENTLY delete this action field? Any Applets that use the parent action will also be deleted."
    )
    if (confirm) {
      let url = `/services/${this.props.service_slug}/actions/${this.props.action_id}/action_fields/${this.props.slug}`
      del(url)
        .then(() => {
          displayFlash("Action field deleted")
        })
        .catch(() => {
          displayFlash(
            "There has been an error deleting the action field.",
            "error"
          )
        })
    }
  }

  findBySlug(slug) {
    return find(fieldTypes, { slug })
  }

  findItemIdByValue(value) {
    for (let el of fieldTypes) {
      let item = find(el.items, { value })
      if (item !== undefined) {
        return item
      }
    }
  }

  findItemIdBySlugAndValue(slug, value) {
    const matchingFieldType = fieldTypes.find(el => el.slug === slug)
    if (matchingFieldType) return find(matchingFieldType.items, { value })
  }

  findItemIdById(itemId) {
    for (let el of fieldTypes) {
      let item = find(el.items, { id: itemId })
      if (item !== undefined) {
        return item
      }
    }
  }

  fieldTypeWillChange() {
    return this.props.action_field_type !== this.selectedActionFieldValue()
  }

  staticFields() {
    return (
      <div className="field">
        <label />
        <div className="input">
          <div className="dropdown-static-fields action-option">
            <div className="dropdown-static-fields-row">
              <div className="dropdown-static-field label">
                <label>Label</label>
              </div>
              <div className="dropdown-static-field label">
                <label>Value</label>
              </div>
              <div className="delete-row">&nbsp;</div>
            </div>

            {this.state.populatedStaticValues.map((entry, key) =>
              this.renderStaticField(key, entry.name, entry.value)
            )}

            <p>
              <span
                onClick={this.handleClickAddStaticField}
                className="button-tertiary"
              >
                Add an option
              </span>
              {this.state.errors.populator_values
                ? this.displayError(this.state.errors.populator_values)
                : ""}
            </p>
          </div>
        </div>
      </div>
    )
  }

  dynamicField() {
    const value = this.state.slug
      ? this.props.populatorTemplate.replace(/{{slug}}/, this.state.slug)
      : "Please provide a key name for this action field"

    return (
      <div className="field">
        <label>API endpoint to populate the options</label>
        <div className="input">
          <input
            type="text"
            value={value}
            data-copy-field-on-click="API endpoint"
            disabled={!this.state.slug}
            readOnly
          />
        </div>
      </div>
    )
  }

  radioOptions(item, index) {
    const itemId = `content_type_${item.value}`
    return (
      <div className="input input-group" key={index}>
        <input
          type="radio"
          name="content_type"
          id={itemId}
          checked={this.state.contentType === item.value}
          value={item.value}
          onChange={this.handleContentTypeChange}
        />
        <label htmlFor={itemId}>{item.name}</label>
      </div>
    )
  }

  groupedOptions() {
    if (this.state.fieldType.indexOf("TEXT") != -1) {
      const radioItems = this.findBySlug("text_field_content_type").items
      const groups = groupBy(radioItems, "group")
      const radioGroups = _map(groups, i => i)
      const options = radioGroups.map(function radioGroup(items) {
        const radios = items.map((item, index) =>
          this.radioOptions(item, index)
        )
        const groupName = items[0].group
        return (
          <div className="field" key={groupName}>
            <label>{groupName}</label>
            {radios}
          </div>
        )
      }, this)
      return options
    }
  }

  populatorOptions() {
    if (this.state.fieldType === "COLLECTION_SELECT") {
      return (
        <div className="fieldset">
          <div className="field">
            <label>Data source for dropdown list</label>
            <div className="input">
              <div className="input-group">
                <input
                  type="radio"
                  name="dropdown_field_type"
                  id="partners_action_field_dropdown_field_type_static"
                  value="dropdown_static"
                  checked={this.state.populatorType === "dropdown_static"}
                  onChange={this.handlePopulatorTypeChange}
                />
                <label htmlFor="partners_action_field_dropdown_field_type_static">
                  Populate with list items specified here
                </label>
              </div>
              <div className="input-group">
                <input
                  type="radio"
                  name="dropdown_field_type"
                  id="partners_action_field_dropdown_field_type_dynamic"
                  value="dropdown_dynamic"
                  checked={this.state.populatorType === "dropdown_dynamic"}
                  onChange={this.handlePopulatorTypeChange}
                />
                <label htmlFor="partners_action_field_dropdown_field_type_dynamic">
                  Retrieve list items from my service
                </label>
              </div>
            </div>
          </div>
          {this.state.populatorType === "dropdown_dynamic"
            ? this.dynamicField()
            : this.staticFields()}
        </div>
      )
    } else if (this.state.fieldType === "CHECKBOX_MULTI") {
      return (
        <div className="fieldset">
          <div className="field">
            <label>Data source for checkbox list</label>
            <div className="input">
              <div className="input-group">
                <input
                  type="radio"
                  name="checkbox_field_type"
                  id="partners_action_field_checkbox_field_type_static"
                  value="checkbox_static"
                  checked={this.state.populatorType === "checkbox_static"}
                  onChange={this.handlePopulatorTypeChange}
                />
                <label htmlFor="partners_action_field_checkbox_field_type_static">
                  Populate with checkbox items specified here
                </label>
              </div>
              <div className="input-group">
                <input
                  type="radio"
                  name="checkbox_field_type"
                  id="partners_action_field_checkbox_field_type_dynamic"
                  value="checkbox_dynamic"
                  checked={this.state.populatorType === "checkbox_dynamic"}
                  onChange={this.handlePopulatorTypeChange}
                />
                <label htmlFor="partners_action_field_checkbox_field_type_dynamic">
                  Retrieve checkbox items from my service
                </label>
              </div>
            </div>
          </div>
          {this.state.populatorType === "checkbox_dynamic"
            ? this.dynamicField()
            : this.staticFields()}
        </div>
      )
    } else if (this.state.fieldType === "DOUBLE_COLLECTION_SELECT") {
      return <div className="fieldset">{this.dynamicField()}</div>
    }
  }

  parseErrors(errors) {
    let _errors = {}
    errors.forEach(error => {
      return (_errors[error.attribute] = error.message)
    })
    this.setState({ errors: _errors })
  }

  displayError(str) {
    return <span className="error-message">Error: {str}</span>
  }

  displayDeleteOption() {
    if (this.props.id !== undefined && this.props.platformUnpublished)
      return (
        <a
          href=""
          className="secondary-action delete"
          onClick={this.handleClickDeleteActionField}
        >
          Delete action field
        </a>
      )
  }

  renderStaticField = (index, name, value) => {
    const keyName = `key-${index}`
    const valueName = `value-${index}`
    return (
      <div className="dropdown-static-fields-row" key={keyName}>
        <div className="dropdown-static-field">
          <input
            type="text"
            name={keyName}
            value={name}
            className="key"
            onChange={e => {
              this.populateStaticValues(index, "name", e.target.value)
            }}
          />
        </div>
        <div className="dropdown-static-field">
          <input
            type="text"
            name={valueName}
            value={value}
            className="value"
            onChange={e => {
              this.populateStaticValues(index, "value", e.target.value)
            }}
          />
        </div>
        <div className="delete-row">
          <span
            onClick={() => {
              this.handleClickRemoveStaticField(index)
            }}
            className="remove-element"
          >
            ×
          </span>
        </div>
      </div>
    )
  }

  render() {
    return (
      <form className="service-edit form">
        <section>
          <div className="list-item-form">
            <div className="field">
              <div className="label">
                <label htmlFor="partners_action_field_name">Label</label>
              </div>
              <div className="input">
                <input
                  type="text"
                  name="partners_action_field[name]"
                  id="partners_action_field_name"
                  value={this.state.name}
                  onChange={this.handleNameChange}
                  onBlur={this.handleNameBlur}
                />
              </div>
              <p className="note">
                Include a leading statement — use a question where possible{" "}
                {this.state.errors.name
                  ? this.displayError(this.state.errors.name)
                  : ""}
              </p>
            </div>

            <div className="field">
              <div className="label">
                <label htmlFor="partners_action_field_helper_text">
                  Optional helper text
                </label>
              </div>
              <div className="input">
                <input
                  type="text"
                  name="partners_action_field[helper_text]"
                  id="partners_action_field_helper_text"
                  value={this.state.helperText}
                  onChange={this.handleHelperTextChange}
                />
              </div>
              <p className="note">
                Markdown-style links allowed{" "}
                {this.state.errors.helper_text
                  ? this.displayError(this.state.errors.helper_text)
                  : ""}
              </p>
            </div>

            <div className="field">
              <div className="label">
                <label htmlFor="partners_action_field_slug">Key name</label>
              </div>
              <div className="input">
                <input
                  type="text"
                  name="partners_action_field[slug]"
                  id="partners_action_field_slug"
                  value={this.state.slug}
                  onChange={this.handleSlugChange}
                />
              </div>
              <p className="note">
                In snake_case
                {this.state.errors.slug
                  ? this.displayError(this.state.errors.slug)
                  : ""}
              </p>
            </div>

            <div className="field">
              <div className="label">
                <label>Required</label>
              </div>
              <div className="input">
                <div className="input-group">
                  <input
                    type="radio"
                    name="partners_action_field[required]"
                    id="partners_action_field_required"
                    value="true"
                    checked={this.state.required === "true"}
                    onChange={this.handleRequiredChange}
                  />
                  <label htmlFor="partners_action_field_required">
                    This action field is required for Applets to work.
                  </label>
                </div>
                <div className="input-group">
                  <input
                    type="radio"
                    name="partners_action_field[required]"
                    id="partners_action_field_not_required"
                    value="false"
                    checked={this.state.required === "false"}
                    onChange={this.handleRequiredChange}
                  />
                  <label htmlFor="partners_action_field_not_required">
                    This action field is optional.
                  </label>
                </div>
              </div>
            </div>

            <div className="field">
              <div className="label">
                <label htmlFor="partners_action_field_shareable">Private</label>
              </div>
              <div className="input">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    name="partners_action_field[shareable]"
                    id="partners_action_field_shareable"
                    defaultChecked={this.state.shareable === "false"}
                    onChange={this.handleShareableChange}
                  />

                  <span />
                  <span>
                    <span className="checkbox-body">
                      Keep the contents of this action field private.
                    </span>
                  </span>
                </label>
              </div>

              <p className="note">
                Does this field require an input that is user-specific (e.g.
                personal device, email address, user profile)? If so, mark as
                private so this field is left blank in published Applets. Note:
                ingredients are not available for use in private fields.
              </p>
            </div>

            <div className="field">
              <div className="label">
                <label>Action field type</label>
              </div>
              <div className="input">
                <div className="input-group">
                  <input
                    type="radio"
                    name="partners_action_field[field_type]"
                    id="partners_action_field_field_type_text_field"
                    value="TEXT_FIELD"
                    checked={this.state.fieldType.indexOf("TEXT") != -1}
                    onChange={this.handleFieldTypeChange}
                  />
                  <label htmlFor="partners_action_field_field_type_text_field">
                    Text input
                  </label>
                </div>
                <div className="input-group">
                  <input
                    type="radio"
                    name="partners_action_field[field_type]"
                    id="partners_action_field_field_type_collection_select"
                    value="COLLECTION_SELECT"
                    checked={this.state.fieldType === "COLLECTION_SELECT"}
                    onChange={this.handleFieldTypeChange}
                  />
                  <label htmlFor="partners_action_field_field_type_collection_select">
                    Dropdown list
                  </label>
                </div>
                <div className="input-group">
                  <input
                    type="radio"
                    name="partners_action_field[field_type]"
                    id="partners_action_field_field_type_double_collection_select"
                    value="DOUBLE_COLLECTION_SELECT"
                    checked={
                      this.state.fieldType === "DOUBLE_COLLECTION_SELECT"
                    }
                    onChange={this.handleFieldTypeChange}
                  />
                  <label htmlFor="partners_action_field_field_type_double_collection_select">
                    Nested dropdown list
                  </label>
                </div>

                <div className="input-group">
                  <input
                    type="radio"
                    name="partners_action_field[field_type]"
                    id="partners_action_field_field_type_checkbox_multi"
                    value="CHECKBOX_MULTI"
                    checked={this.state.fieldType === "CHECKBOX_MULTI"}
                    onChange={this.handleFieldTypeChange}
                  />
                  <label htmlFor="partners_action_field_field_type_checkbox_multi">
                    Multiple checkbox selection
                  </label>
                </div>
              </div>
            </div>

            <div className="grouped-field">
              {this.groupedOptions()}
              {this.populatorOptions()}
            </div>

            <div className="actions">
              <div className="action-left">{this.displayDeleteOption()}</div>
              <div className="action-right">
                <a
                  href=""
                  className="secondary-action"
                  data-action="cancel-form"
                  data-load-form-async="action-fields"
                >
                  Cancel
                </a>
                <button
                  className="button-secondary"
                  onClick={this.handleClickSave}
                  data-disable-with="Saving…"
                  disabled={!this.props.platformUnpublished}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </section>
      </form>
    )
  }
}
